// A receipt can arrive before another RPC reader sees the new registry state.
// Retry only publication of the identical, already-proven record; never relay
// the transaction again. Conflicting ownership/version records still fail.
export async function publishHandleRecord(
  token: string,
  record: unknown,
): Promise<void> {
  const body = JSON.stringify(record);
  const delays = [1_000, 2_000, 4_000];
  for (let attempt = 0; ; attempt++) {
    const response = await fetch("/api/handles/publish", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body,
    });
    const data = await response.json().catch(() => ({}));
    if (response.ok) return;
    const message = String(
      data?.error || `Publish failed (${response.status})`,
    );
    const waitingForRegistry =
      (response.status === 409 &&
        message === "Handle record does not match current onchain state") ||
      (response.status === 503 &&
        message === "Handle registry verification unavailable");
    if (!waitingForRegistry || attempt >= delays.length)
      throw new Error(message);
    await new Promise((resolve) => setTimeout(resolve, delays[attempt]));
  }
}
